export const experienceData = [
    {
        id: 1,
        company: 'Hackbright Academy, San Francisco, CA',
        jobtitle: 'Student Engineer',
        startYear: 'June 2022',
        endYear: 'October 2022'
    },
    {
        id: 2,
        company: 'Texas Tech University, Lubbock, TX',
        jobtitle: 'Graduate Teaching Assistant',
        startYear: '2020',
        endYear: '2022'
    },
    {
        id: 3,
        company: 'Arbor hotels',
        jobtitle: 'Graduate Intern',
        startYear: 'May 2021',
        endYear: 'Aug 2021'
    },
]